import React from 'react'

const GuideText = () => {
  const handleClick = () => {
    setTimeout(function () {
      document.querySelector('.modal-container').style.display = 'flex'

      var difficultyModal = document.querySelector('.difficulty-modal')
      if (difficultyModal.classList.contains('difficulty-modal-close')) {
        difficultyModal.classList.remove('difficulty-modal-close')
      }
    }, 150)

    var container = document.querySelector('.ref-container')
    var difficultyModal = document.querySelector('.difficulty-modal')

    if (container.offsetHeight < difficultyModal.offsetHeight) {
      var extendedHeight = difficultyModal.offsetHeight + 200
      container.style.height = extendedHeight + 'px'
    }

    var blueOverlay = document.querySelector('.blue-overlay')
    blueOverlay.style.zIndex = '1031'
    blueOverlay.style.opacity = '1'
  }
  return (
    <div className='dif-intens-guide'>
      <div className='guide guide-mobile'>
        <a className='link' href='/difficulty'>
          Difficulty & Intensity Guide
        </a>
      </div>
      <div onClick={handleClick} className='guide guide-lg'>
        Difficulty & Intensity Guide
      </div>
    </div>
  )
}

export default GuideText
